module.exports = __webpack_public_path__ + "static/media/promo-dlitelnoe.e673e42f.jpg";